import {useState} from "react"

export default function useAreas() {

    const areas = ["Kopaonik", "Stara planina", "Tornik", "OPU"]
    const mountains = ["Kopaonik", "Stara planina", "Tornik"]
    const defaultArea = mountains[0]
    const [area, setArea] = useState(defaultArea)

    return {areas, mountains, defaultArea, area, setArea}
}